export const api = "https://tcode.online/api/zaman";